/*
 *     Copyright (c) 2020 Bcame S.r.l.. All rights reserved.
 *     Bcame S.r.l. Technology Business Unit
 *
 *     Company confidential.
 *
 *     This software is proprietary  to and embodies the confidential
 *     technology of Bcame S.r.l..  Possession, use, or copying of this
 *     software and media is authorized only pursuant to a valid written
 *     license from Bcame S.r.l.  or an authorized sublicensor.
 *
 *     Bcame S.r.l.
 */
import Vue from 'vue'
import mutations from '@/store/modules/listing/mutations'

mutations.concatProduct = (state, products) => {
  state.list = state.list.concat(...products)
}

mutations.setAvailableFilters = (state, { filters }) => {
  const available = {}
  const exclusion = ['category_id', 'c_categoriesRefinement', 'EAN']
  let chosenEmpty = Object.keys(state.filters.chosen).length === 0
  let chosenValues = {}
  for (let i in filters) {
    const attrCode = filters[i].attribute_code
    if (!exclusion.includes(attrCode)) {
      available[attrCode] = {
        label: filters[i].label,
        options: filters[i].options
      }
      if (chosenEmpty) {
        chosenValues[attrCode] = []
      }
    }
  }
  if (chosenEmpty) {
    Vue.set(state.filters, 'temporary', chosenValues)
  }
  Vue.set(state.filters, 'available', available)
}

mutations.updateTemporaryFilters = (state, { attrCode, valueSelected }) => {
  state.filters.temporary[attrCode] = valueSelected
}

mutations.clearFilters = (state) => {
  state.filters.chosen = state.filters.temporary = {}
}

mutations.setFiltersChosen = (state, filters) => {
  Vue.set(state.filters, 'chosen', filters)
}

mutations.setQuickViewForInstantSearch = (state, value) => {
  state.quickViewInstantSearch = value
}

export default {
  ...mutations
}
